export type SessionLoad =
  | { status: "signedIn"; user: User }
  | { status: "signedOut" }
  | { status: "unreachable"; error: Error };

interface Options {
  attempts?: number;
  retryDelayMs?: number;
  wait?(ms: number): Promise<void>;
}

const delay = (ms: number) => new Promise<void>((resolve) => setTimeout(resolve, ms));

const isUnauthorized = (error: unknown) => (error as { status?: number })?.status === 401;

export const loadSession = async (
  fetchMe: () => Promise<User>,
  { attempts = 3, retryDelayMs = 1000, wait = delay }: Options = {}
): Promise<SessionLoad> => {
  for (let attempt = 1; ; attempt++) {
    try {
      return { status: "signedIn", user: await fetchMe() };
    } catch (error) {
      if (isUnauthorized(error)) {
        return { status: "signedOut" };
      }
      if (attempt >= attempts) {
        return { status: "unreachable", error: error as Error };
      }
      await wait(retryDelayMs * attempt);
    }
  }
};
